module.exports = __webpack_public_path__ + "img/download-on-app-store-en.60093c68.svg";